import CardBlock     from './../../widgets/CardBlock'
import CalendarBlock from './../../widgets/CalendarBlock'
import MapBlock      from './../../widgets/MapBlock'
import DailyPanel    from './../../widgets/DailyPanel'
import TicketsPanel  from './../../widgets/TicketsPanel'

export default {
  name:       'GridStack',
  props:      ['data', 'customizeSizing'],
  components: {
    CardBlock,
    CalendarBlock,
    MapBlock,
    DailyPanel,
    TicketsPanel
  },
  data () {
    return {
      items: []
    }
  },

  watch: {
    'data': function (data) {
      this.preprocessData()
    }
  },

  created () {
    this.preprocessData()
  },

  mounted () {
    let options = {
      cellHeight:     70,
      verticalMargin: 10
    }

    $(this.$refs.element).gridstack(options)
  },

  methods: {
    preprocessData () {
      this.items = []

      let gsx = 0,
          gsy = 0

      for (let i = 0; i < this.data.length; i++) {
        let dataItem = this.data[i]

        if (!dataItem.hasOwnProperty('Layout')) {
          continue
        }

        let layout = dataItem.Layout.split(',')

        dataItem['gsx'] = layout[0]
        dataItem['gsy'] = layout[1]

        if (dataItem.FieldType === 'ENUKPI' && !this.customizeSizing) {
          dataItem['gswidth']  = 2
          dataItem['gsheight'] = 2
        }
        else {
          dataItem['gswidth']  = layout[2]
          dataItem['gsheight'] = layout[3]
        }

        this.items.push(dataItem)
      }
    }
  }
}
